<template>
  <div class="loginClient">
    <div class="container">
      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-5">
          <CCard class="p-4 register-card">
            <CCardBody>
              <CForm @submit.prevent="performRegister">
                <center>
                  <h1 style="color:#fd131a">Inscription</h1>
                  <p class="text-muted">Session Equipe</p>
                </center>

                <!-- Nom / Prénom -->
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <CInput required placeholder="Nom" v-model="nom">
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                  </div>

                  <div class="col-12 col-md-6 mb-3">
                    <CInput required placeholder="Prénom" v-model="prenom">
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                  </div>
                </div>

                <!-- Login -->
                <CInput
                  required
                  placeholder="Login ..."
                  v-model="login"
                  class="mb-3"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>

                <!-- Password -->
                <div class="password-wrapper mb-2">
                  <CInput
                    required
                    placeholder="Mot de passe ..."
                    :type="show ? 'text' : 'password'"
                    v-model="password"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked" />
                    </template>
                  </CInput>

                  <i
                    class="fas"
                    :class="show ? 'fa-eye' : 'fa-eye-slash'"
                    @click="show = !show"
                  ></i>

                  <div
                    class="strength"
                    :class="'level_' + strengthLevel"
                  ></div>
                </div>

                <!-- Button -->
                <CButton
                  type="submit"
                  color="primary"
                  block
                  class="mt-4"
                >
                  {{ isLoading ? "En cours..." : "S'inscrire" }}
                </CButton>

                <!-- Link login -->
                <div class="text-center mt-3">
                  <router-link  style="color:#000000" to="/">
                    Vous avez déjà un compte ?
                    <b style="color:#fd131a">Se connecter</b>
                  </router-link>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { apiDomain } from "../../config";
export default {
  components: {},
  name: "login",
  data() {
    return {
      tokenVerifEmail: "",
      isLoadingVerifEmail: false,
      errorTokenVerifEmail: null,
      infoVerifEmail: null,
      showLogin: false,

      login: "",
       nom: "",
        prenom: "",
      password: "",
      login: "",
      infoModal: false,
      loggedIn: false,
      //error: "",
      isCreating: false,
      show: false,
      formstate: {},
      validationErrors: "",
      //modifier password
      password: "",
      password_confirmation: "",

      erreurEmail: null,
      token: "",
      errorToken: null,
      newPassword: "",
      errornewPaswword: null,
      passwordAgain: "",
      errorpasswordAgain: null,
      tokenValid: false,
      EmailValid: false,
      infoEmail: null,
      infoToken: null,

      user: null,
      infoToken1: "Verifier avec Succès",

      status_msg: "",
      status: "",
      //error: "",
      errors: [],
      isLoading: false,
    };
  },

  computed: {
    isPasswordMatching() {
      if (
        this.password == "" ||
        this.password_confirmation == "" ||
        this.password != this.password_confirmation
      )
        return true;
      return false;
    },
  },

  mounted() {},

  methods: {
    showNotification(message) {
      this.status_msg = message;
      setTimeout(() => {
        this.status_msg = "";
      }, 120000);
    },

    performRegister() {
      this.isLoading = true;
      this.$store
        .dispatch("performRegisterClientAction", {
          nom: this.nom,
          prenom: this.prenom,
          login: this.login,
          password: this.password,
        })
        .then((res) => {
          this.isLoading = false;
          this.$noty.success("Connexion réussie.");
          this.$router.push("/vidange");
        })
        .catch((error) => {
          console.log(error.response.data);
          if (error.response.status == 422) {
            this.isLoading = false;
            this.errors = error.response.data.errors;
          }
          if (error.response.status == 401) {
            this.isLoading = false;

            this.$noty.error("OOPS! Login ou password invalid");
          }
          if (error.response.status == 403) {
            this.isLoading = false;

            this.$noty.error("OOPS! Votre Compte n'est pas activer");
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("https://use.fontawesome.com/releases/v5.7.2/css/all.css");

/* Background image */
.registerClient {
  min-height: 100vh;
  background:
    linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
    url("/assets/img/login-bg.jpg") no-repeat center center;
  background-size: cover;
}

/* Card */
.register-card {
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 15px 35px rgba(0,0,0,0.15);
}

/* Password */
.password-wrapper {
  position: relative;
}

.password-wrapper i {
  position: absolute;
  right: 15px;
  top: 0;
  cursor: pointer;
  color: #555;
}

/* Strength bar */
.strength {
  height: 4px;
  margin-top: 6px;
  border-radius: 20px;
  transition: width 0.4s ease;
}

.level_0 { width: 25%; background: #bb4440; }
.level_1 { width: 25%; background: #bb4440; }
.level_2 { width: 50%; background: #e17d30; }
.level_3 { width: 75%; background: #f0b03f; }
.level_4 { width: 100%; background: #a5df41; }

/* Mobile */
@media (max-width: 576px) {
  .register-card {
    padding: 20px !important;
  }

  h1 {
    font-size: 1.6rem;
  }
}

/* Tablet */
@media (min-width: 577px) and (max-width: 991px) {
  .register-card {
    padding: 25px !important;
  }
}

/* Desktop */
@media (min-width: 992px) {
  .register-card {
    padding: 30px !important;
  }
}

</style>
